import axios from "axios";

export async function execGetRequestsWithParams(
  endpoint,
  param,
  configheaders
) {
  let config = {
    headers: configheaders,
    params: param,
  };
  try {
    const apiResponse = await axios.get(endpoint, config);
    if (apiResponse.issuccess === 0) {
      return "error";
    } else {
      return apiResponse;
    }
  } catch (err) {
    //console.log(err);
  }
}

export function execGetRequestsWithParamsDownloadFile(endpoint, filename, configheaders, param) {
  axios({
    url: endpoint, // Interface name
    method: "get",
    headers: configheaders,
    params: param,
    responseType: "blob",
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
    })
  // .catch((err) => //console.log(err));
}

export async function execGetRequestsWithoutParams(endpoint, configheaders) {
  try {
    const apiResponse = await axios.get(endpoint, { headers: configheaders });

    if (apiResponse.issuccess === 0) {
      return "error";
    } else {
      return apiResponse;
    }
  } catch (err) {
    //console.log(err);
  }
}

export function execGetRequests(endpoint) {
  axios
    .get(endpoint)
    .then((res) => {
      if (res.issuccess === 0) {
        return "error";
      } else {
        return res.data;
      }
    })
  // .catch((err) => //console.log(err));
}
export function execGetRequestsDownloadFile(endpoint, filename, configheaders) {
  axios({
    url: endpoint, // Interface name
    method: "get",
    headers: configheaders,

    responseType: "blob",
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
    })
  // .catch((err) => //console.log(err));
}

export function execPostRequestsDownloadFile(
  endpoint,
  filename,
  configheaders,
  postdata
) {
  axios({
    url: endpoint, // Interface name
    method: "post",
    headers: configheaders,
    data: postdata,
    responseType: "blob",
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      // const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link

      window.open(href);
      //   aEle.href = href;
      //   aEle.download = filename; // File name after download
      //   document.body.appendChild(aEle);
      //   aEle.click(); // Click to download
      //   document.body.removeChild(aEle); // Download complete remove element
      //   window.URL.revokeObjectURL(href); // Release blob object
    })
  // .catch((err) => //console.log(err));
}


export async function execPostRequestsDownloadFile1(
  endpoint,
  postdata,
  filename,
  configheaders
) {
  let returnResp;

  if (!configheaders) configheaders = {};
  if (configheaders && !configheaders.user_email) configheaders.user_email = sessionStorage.getItem('user_email');
  if (configheaders && !configheaders.token) configheaders.token = sessionStorage.getItem('token');
  await axios({
    url: endpoint, // Interface name
    method: "post",
    headers: configheaders,
    responseType: "blob",
    data: postdata,
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
    })
    .catch(async (err) => {

      let responseObj = await err.response.data.text();
      returnResp = JSON.parse(responseObj);
    }
    );
  return returnResp
}

export async function execPostRequest(endpoint, postdata, configheaders) {
  try {
    const apiResponse = await axios({
      url: endpoint, // Interface name
      method: "post",
      headers: configheaders,
      data: postdata,
    });
    return apiResponse.data;
  } catch (err) {
    return err.response.data;
  }
}
export async function execPutRequestWithParams(
  endpoint,
  param,
  postdata,
  configheaders
) {
  try {
    const apiResponse = await axios({
      url: endpoint, // Interface name
      method: "put",
      headers: configheaders,
      data: postdata,
      params: param,
    });
    return apiResponse.data;
  } catch (err) {
    //console.log(err);
    return err && err.response && err.response.data ? err.response.data : err;
  }
}

export async function execMultiPartRequestWithParams(endpoint, param, postdata, configheaders) {
  try {
    const apiResponse = await axios({
      url: endpoint, // Interface name
      method: "post",
      headers: configheaders,
      data: postdata,
      params: param,
      "content-type": "multipart/form-data",
    });
    return apiResponse.data;
  } catch (err) {
    //console.log(err);
    return err.response.data;
  }
}

export async function execMultiPartRequest(endpoint, postdata, configheaders) {
  try {
    const apiResponse = await axios({
      url: endpoint, // Interface name
      method: "post",
      headers: configheaders,
      data: postdata,
      "content-type": "multipart/form-data",
    });
    return apiResponse.data;
  } catch (err) {
    //console.log(err);
    return err.response.data;
  }
}

export async function execDeleteRequestsWithParams(
  endpoint,
  param,
  configheaders
) {
  let config = {
    headers: configheaders,
    params: param,
  };
  try {
    const apiResponse = await axios.delete(endpoint, config);
    if (apiResponse.issuccess === 0) {
      return "error";
    } else {
      return apiResponse;
    }
  } catch (err) {
    //console.log(err);
  }
}

export default {
  execGetRequestsWithParams,
  execGetRequestsWithoutParams,
  execGetRequests,
  execGetRequestsDownloadFile,
  execPostRequest,
  execPutRequestWithParams,
  execMultiPartRequest,
  execMultiPartRequestWithParams,
  execPostRequestsDownloadFile,
  execPostRequestsDownloadFile1,
  execDeleteRequestsWithParams,
  execGetRequestsWithParamsDownloadFile
};
